export default __webpack_public_path__ + "static/media/delete-icon.dc8ef668.svg";